import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import Reveal from "../Reveal";

const items = [
  {
    q: "Wat kost een complete badkamerrenovatie?",
    a: "De prijs hangt af van afmetingen, materiaalkeuze en indeling. Tijdens het gratis adviesgesprek meten we de ruimte op en geven we een transparante vaste prijsopgave — geen verrassingen achteraf.",
  },
  {
    q: "Hoe lang duurt een badkamerrenovatie?",
    a: "De meeste renovaties leveren we binnen enkele dagen op, afhankelijk van de omvang en materiaalkeuze. Tijdens het gratis adviesgesprek geven we u een concrete planning op maat.",
  },
  {
    q: "Is het adviesgesprek echt gratis en vrijblijvend?",
    a: "Ja, helemaal gratis en vrijblijvend. We komen bij u thuis of op uw bedrijfslocatie, bespreken uw wensen en mogelijkheden, en maken een vrijblijvende offerte. U zit nergens aan vast.",
  },
  {
    q: "Werken jullie ook in mijn regio?",
    a: "Wij werken in heel Nederland — voor zowel particuliere badkamers als zakelijke toiletruimtes in bedrijfspanden, horeca en kantoren.",
  },
  {
    q: "Krijg ik garantie op de renovatie?",
    a: "Ja, op al ons werk en de geleverde materialen krijgt u standaard garantie. De exacte voorwaarden ontvangt u schriftelijk bij oplevering.",
  },
  {
    q: "Regelen jullie alles van A tot Z?",
    a: "Ja — tegelwerk, sanitair, loodgieterswerk, elektra, verlichting en vloerverwarming. Eén aanspreekpunt voor het hele traject, van ontwerp tot oplevering.",
  },
  {
    q: "Doen jullie ook alleen een inloopdouche?",
    a: "Zeker. We kunnen ook alleen uw bestaande douche of bad vervangen door een moderne inloopdouche met glas, regendouche en luxe afwerking, zonder de hele badkamer te verbouwen.",
  },
  {
    q: "Hoe verloopt het traject?",
    a: "In 4 stappen: 1) gratis adviesgesprek bij u op locatie, 2) ontwerp en vaste-prijs offerte, 3) vakkundige uitvoering door onze specialisten, 4) oplevering met garantie en instructies.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-[#F5F7FB] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <span className="tag-overline">Veelgestelde vragen</span>
          <h2 className="mt-4 text-5xl md:text-6xl text-[#0A0A0A] leading-[1.02] uppercase tracking-tight">
            Antwoorden op
            <br />
            <span className="text-[#1E5BC6]">uw vragen.</span>
          </h2>
          <p className="mt-6 text-lg text-[#5A5A5A] max-w-md">
            Geen tijd om door alles heen te lezen? Bel direct op{" "}
            <a
              href="tel:+31687445044"
              className="text-[#1E5BC6] font-semibold underline-offset-4 hover:underline"
            >
              +31 6 87445044
            </a>{" "}
            of plan een gratis adviesgesprek.
          </p>
        </Reveal>

        <div className="lg:col-span-7">
          <div className="bg-white border border-[#E5E7EB] divide-y divide-[#E5E7EB]">
            {items.map((it, i) => {
              const isOpen = open === i;
              return (
                <Reveal key={i} delay={i * 40}>
                  <button
                    type="button"
                    data-testid={`faq-toggle-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full text-left flex items-start justify-between gap-6 px-6 md:px-8 py-5 md:py-6 hover:bg-[#F5F7FB] transition-colors group"
                    aria-expanded={isOpen}
                  >
                    <span className="text-base md:text-lg font-semibold text-[#0A0A0A] uppercase tracking-tight group-hover:text-[#1E5BC6] transition-colors">
                      {it.q}
                    </span>
                    <span
                      className={`flex-shrink-0 w-9 h-9 border border-[#E5E7EB] flex items-center justify-center transition-colors ${
                        isOpen
                          ? "bg-[#1E5BC6] border-[#1E5BC6] text-white"
                          : "text-[#1E5BC6]"
                      }`}
                    >
                      {isOpen ? (
                        <Minus size={16} strokeWidth={2.2} />
                      ) : (
                        <Plus size={16} strokeWidth={2.2} />
                      )}
                    </span>
                  </button>
                  <div
                    data-testid={`faq-answer-${i}`}
                    className={`overflow-hidden transition-all duration-500 ease-out ${
                      isOpen
                        ? "max-h-96 opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <p className="px-6 md:px-8 pb-6 md:pb-7 text-[#5A5A5A] leading-relaxed max-w-2xl">
                      {it.a}
                    </p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
